var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.00996 17.5585C-2.2173 6.42732 10.1479 -1.10278 15.6436 6.95262C21.1392 15.008 9.46031 25.5215 8.70101 19.4326C7.72852 11.6341 20.8896 6.03301 27.5918 4.20726","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.0186 1.80981L21.2571 -0.00192606L20.7395 1.92993L27.5009 3.74166L25.6892 10.5031L27.6211 11.0208L29.4328 4.2593L29.9504 2.32745L28.0186 1.80981Z","fill":"black","key":1})]);
}

ArrowInline.defaultProps = {"width":"30","height":"23","viewBox":"0 0 30 23","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
